import { useState, useEffect } from 'react';
import { getUsers, toggleUser, deleteUser } from '../services/api';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => { loadUsers(); }, []);

  const loadUsers = async () => {
    setLoading(true);
    try { setUsers(await getUsers()); } catch (e) {}
    setLoading(false);
  };

  const handleToggle = async (id, name) => {
    if (!window.confirm(`Toggle status for ${name}?`)) return;
    try { await toggleUser(id); loadUsers(); } catch (e) { alert('Failed'); }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Permanently DELETE "${name}" and all their data? This cannot be undone.`)) return;
    try { await deleteUser(id); loadUsers(); alert(`${name} deleted`); }
    catch (e) { alert(e.response?.data?.detail || 'Failed to delete'); }
  };

  const filtered = users.filter(u => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return String(u.id).includes(q) ||
           u.name.toLowerCase().includes(q) ||
           u.email.toLowerCase().includes(q) ||
           (u.phone || '').includes(q);
  });

  const roleBadge = (role) => {
    if (role === 'admin') return <span className="badge badge-danger">Admin</span>;
    if (role === 'worker') return <span className="badge badge-info">Worker</span>;
    return <span className="badge badge-purple">Customer</span>;
  };

  return (
    <div>
      <div className="page-header">
        <h1>Users Management</h1>
        <p>Manage all registered users</p>
      </div>
      <div className="card">
        <div className="card-header">
          <h2>👥 All Users ({filtered.length})</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              placeholder="🔍 Search by ID, name, email, phone..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ padding: '6px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }}
            />
            <button className="refresh-btn" onClick={loadUsers}>🔄 Refresh</button>
          </div>
        </div>
        {loading ? <div className="loading">Loading users...</div> : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Joined</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(u => (
                  <tr key={u.id}>
                    <td>#{u.id}</td>
                    <td><strong>{u.name}</strong></td>
                    <td style={{ fontSize: 13 }}>{u.email}</td>
                    <td style={{ color: '#1565c0', fontWeight: 600 }}>📞 {u.phone}</td>
                    <td>{roleBadge(u.role)}</td>
                    <td>
                      {u.is_active
                        ? <span className="badge badge-success">Active</span>
                        : <span className="badge badge-danger">Inactive</span>}
                    </td>
                    <td>{u.created_at?.substring(0, 10)}</td>
                    <td>
                      <div style={{display:'flex', gap:4}}>
                        <button
                          className={`btn btn-sm ${u.is_active ? 'btn-danger' : 'btn-success'}`}
                          onClick={() => handleToggle(u.id, u.name)}
                        >
                          {u.is_active ? 'Deactivate' : 'Activate'}
                        </button>
                        <button className="btn btn-sm" style={{background:'#666',color:'#fff'}} onClick={() => handleDelete(u.id, u.name)}>
                          🗑️ Remove
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
